/* ============================================================
   KKUMI — DECO WITH ME walkthrough
   Guided, linear step-through for the "how to decorate" module.
   Renders into [data-deco-walk]. Step copy (tag / number / title /
   body / optional media) is merchant-editable — it arrives as a
   JSON array on data-steps. The final-step CTA is rendered in
   Liquid inside [data-wcta] (so its link escapes there); this
   script only toggles its visibility. Contains zero Liquid.
   ============================================================ */
(function () {
  'use strict';

  function initWalk(root) {
    if (root.dataset.kkBound) return;
    root.dataset.kkBound = '1';

    var steps = [];
    try { steps = JSON.parse(root.dataset.steps || '[]'); } catch (e) { steps = []; }
    if (!steps.length) return;
    var clipSuffix = root.dataset.clipSuffix || 'clip 10–15s';
    var nextLabel = root.dataset.nextLabel || 'Next step';
    var restartLabel = root.dataset.restartLabel || 'Start over';
    var vlabelPrefix = root.dataset.vlabelPrefix != null ? root.dataset.vlabelPrefix : 'step ';
    var vlabelSep = root.dataset.vlabelSep != null ? root.dataset.vlabelSep : ' · ';

    var railWrap = root.querySelector('[data-wrail]');
    var titleEl = root.querySelector('[data-wtitle]');
    var bodyEl = root.querySelector('[data-wbody]');
    var numEl = root.querySelector('[data-wnum]');
    var tagEl = root.querySelector('[data-wtag]');
    var bar = root.querySelector('[data-wbar]');
    var prevBtn = root.querySelector('[data-wprev]');
    var nextBtn = root.querySelector('[data-wnext]');
    var cta = root.querySelector('[data-wcta]');
    var vLabel = root.querySelector('[data-wvlabel]');
    var vCard = root.querySelector('[data-wvideo]');
    var vPlay = root.querySelector('[data-wvplay]');
    var vImg = null;
    if (!railWrap) return;

    steps.forEach(function (st, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'dk-rail__dot';
      var num = document.createElement('i');
      num.textContent = st.n || (i + 1);
      var lab = document.createElement('b');
      lab.textContent = st.t || '';
      d.appendChild(num);
      d.appendChild(lab);
      d.addEventListener('click', function () { go(i); });
      railWrap.appendChild(d);
    });
    var dots = Array.prototype.slice.call(railWrap.querySelectorAll('.dk-rail__dot'));

    var cur = 0;
    function go(i) {
      cur = Math.max(0, Math.min(steps.length - 1, i));
      var st = steps[cur];
      titleEl.textContent = st.t || '';
      numEl.textContent = st.n || (cur + 1);
      bodyEl.textContent = st.b || '';
      tagEl.textContent = st.tag || '';
      bodyEl.parentElement.classList.remove('dk-fade'); void bodyEl.offsetWidth; bodyEl.parentElement.classList.add('dk-fade');
      bar.style.width = (((cur + 1) / steps.length) * 100) + '%';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === cur); d.classList.toggle('is-done', di < cur); });
      if (vLabel) vLabel.textContent = vlabelPrefix + (st.n || (cur + 1)) + vlabelSep + (st.t || '') + vlabelSep + clipSuffix;

      /* optional per-step image swaps into the media card */
      if (vCard) {
        if (st.img) {
          if (!vImg) {
            vImg = document.createElement('img');
            vImg.alt = '';
            vCard.insertBefore(vImg, vCard.firstChild);
          }
          vImg.setAttribute('src', st.img);
          vImg.hidden = false;
          if (vPlay) vPlay.hidden = true;
        } else {
          if (vImg) vImg.hidden = true;
          if (vPlay) vPlay.hidden = false;
        }
        vCard.classList.remove('dk-fade'); void vCard.offsetWidth; vCard.classList.add('dk-fade');
      }

      prevBtn.disabled = cur === 0;
      nextBtn.textContent = cur === steps.length - 1 ? restartLabel : nextLabel;
      if (cta) cta.classList.toggle('is-on', !!st.done);
    }
    prevBtn.addEventListener('click', function () { go(cur - 1); });
    nextBtn.addEventListener('click', function () { if (cur === steps.length - 1) go(0); else go(cur + 1); });
    go(0);
  }

  function boot() { document.querySelectorAll('[data-deco-walk]').forEach(initWalk); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
